export default defineNuxtPlugin(({ hook }) => {
  hook('app:created', () => {
    // Load the Jira Service Desk widget script
    const script = document.createElement('script')
    script.setAttribute('data-jsd-embedded', '')
    script.setAttribute('data-key', '67c37bf8-dd04-44e4-abac-8a380de86d4a')
    script.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com')
    script.setAttribute('data-position', 'bottom-right')
    script.setAttribute(
      'src',
      'https://jsd-widget.atlassian.com/assets/embed.js',
    )
    document.head.appendChild(script)

    // Add custom CSS for the widget icon
    const style = document.createElement('style')
    style.innerHTML = '.jira-servicedesk-icon { z-index: 9999 !important; }'
    document.head.appendChild(style)
  })
})
